angular
  .module('questionari.components', [])
  .component('questionari', {
    templateUrl: 'ng/components/questionario/questionari.view.html',
    controllerAs: 'QuestionariCtrl',
    bindings: {
			nextPage: '&?'
		},
    controller: function ($financialService, $rootScope) {
      var self = this;
      self.check = true;
      self.calls = 0;
      self.array = [self.calls];
      self.lastQuestions = {};
      self.hystQuestion = [];
      self.nextQuestionnaireId=[];
      self.lastQuestionsOK = [];
      self.controllo = true;
      self.questionsOK = function (questions) {
        self.check = false;
        self.controllo = true;
        self.prevQuestionnaires = [];
        self.tempo = self.lastQuestions;
        self.tempo.forEach(function (v) {
          v.answers = v.answers.map(function (answer) {
            var value = questions.filter(function (question) {
              return question.label == v.question.code
            })[0].value;
            return {
              code: answer.code, 
              text: answer.text,
              selected: value == answer.code ? true : false
            }
          });
        });
        self.lastQuestionsOK = self.lastQuestionsOK.concat(self.tempo);
        self.prevQuestionnaires.push({
          type: "STRUMENTALE",
          questions: self.lastQuestionsOK
        });
        self.tempo = [];
        self.temp2 = [];
        if (self.calls > 2) {
          self.nextPage();
          self.controllo = false;

        } else {
          console.log('nextQuestionnaire: ',self.nextQuestionnaireId[self.calls]);
          $financialService.getQuestionario(self.nextQuestionnaireId[self.calls], self.prevQuestionnaires)
            .then(function (resp) {
              self.lastQuestions = [];
              if (resp.dloGetQuestionarioOutput && resp.dloGetQuestionarioOutput != "") {
                var info = resp.dloGetQuestionarioOutput.questions;
                self.calls = self.calls + 1;
                self.array.push(self.calls);
                self.nextQuestionnaireId.push(resp.dloGetQuestionarioOutput.nextQuestionnaireId);
                info.forEach(function (s) {
                  self.temp2.push({
                    label: s.question.code,
                    no_label: s.answers[0].code,
                    yes_label: s.answers[1].code,
                    required: true
                  });
                });
                //Map input
                self.temp2 = self.temp2.map(function (v) {
                  return {
                    'label': v.label,
                    'no_label': v.no_label,
                    'yes_label': v.yes_label,
                    'value': '',
                    'required': v.required ? true : false
                  }
                });
                self.lastQuestions = resp.dloGetQuestionarioOutput.questions;
                self.hystQuestion.push(self.temp2);
              } else {
                self.nextPage();
              }
            })
            .finally(function () {
              self.controllo = false;
            });
        }
      }

      self.$onInit = function () {
        var beni = 'BENI';
        self.nextQuestionnaireId.push ('BENI');
        if (self.check) {
          $financialService.getQuestionario(beni, null)
            .then(function (resp) {
              var info = resp.dloGetQuestionarioOutput.questions;
              self.nextQuestionnaireId.push(resp.dloGetQuestionarioOutput.nextQuestionnaireId);
              self.temp = [];
              self.lastQuestions = info;
              info.forEach(function (s) {
                self.temp.push({
                  label: s.question.code,
                  no_label: s.answers[0].code,
                  yes_label: s.answers[1].code,
                  required: true
                });
              });
              self.temp = self.temp.map(function (v) {
                return {
                  'label': v.label,
                  'no_label': v.no_label,
                  'yes_label': v.yes_label,
                  'value': '',
                  'required': v.required ? true : false
                }
              });
              self.hystQuestion.push(self.temp);
            })
            .finally(function () {
              self.calls = self.calls + 1;
              self.controllo = false;
            });
        }
      }
    }
  });